import { Menu } from '@mui/material';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { BsArrowDownShort, BsArrowUpShort } from 'react-icons/bs';
import { FiChevronDown } from 'react-icons/fi';
import { HiSearch } from 'react-icons/hi';
import { PiCursor, PiForkKnifeLight, PiShoppingBag, PiTruckLight } from 'react-icons/pi';
import { useDispatch, useSelector } from 'react-redux';
import Sort from 'src/assets/images/SortAscending.svg';
import {
  addCurrentOrder,
  addCurrentUser,
  clearCurrentOrder,
} from 'src/redux/action/currentOrder.action';
import { RootState } from 'src/redux/reducers';
import ReactDatePicker from 'react-datepicker';
import { BiChevronDown } from 'react-icons/bi';
import Button from 'src/components/button';
import Modal from 'src/components/modal';
import { payment_status, PaymentStatusButton } from 'src/components/payment-status';
import { NoTicket } from 'src/components/tickets';
import { CurrencyAmount } from 'src/containers/currency';
import SingleOrder from 'src/pages/orders/singleOrder';
import { triggerOrdersRefetch, updateOrderDate, updateOrderFilters, updateOrderItemsCache, updateOrderPaymentType } from 'src/redux/action/orderItems.action';
import Service from 'src/setup/network';
import { endOfToday, oneWeekAgoDate } from 'src/utils/dateOneMonthAgo';

const ClosedTickets: React.FC = () => {
  const { orderStartDate, orderEndDate, ordersCache, filters, orderPaymentType, refetch } = useSelector(({ orderItemsData }: RootState) => orderItemsData);
  const [orderData, setOrderData] = useState<any[]>(ordersCache?.data || []);
  const [initPage, setInitPage] = useState(false);
  const [anchorElFilter, setAnchorElFilter] = React.useState<null | HTMLElement>(null);
  const openDisc = Boolean(anchorElFilter);
  const getEndOfDay = (date: Date) => {
    const endOfDate = new Date(date);
    endOfDate.setHours(23, 59, 59, 999);
    return endOfDate;
  };
  const getStartOfDay = (date: Date) => {
    const startOfDate = new Date(date);
    startOfDate.setHours(0, 0, 0, 0);
    return startOfDate;
  };
  const [dateQuery, setDateQuery] = useState<any>(
    `&from=${getStartOfDay(orderStartDate || oneWeekAgoDate()).toISOString()}&to=${getEndOfDay(orderEndDate || endOfToday()).toISOString()}`
  );
  const [selectedTicket, setSelectedTicket] = useState('');
  const [filteredText, setFilteredText] = useState('');
  const [filteredOrderType, setFilteredOrderType] = useState<string[]>([
    'dine_in',
    'takeaway',
    'delivery',
    'online_order',
  ]);
  const [filteredSortBy, setFilteredSortBy] = useState('createdUp');
  const [filterFloors, setFilterFloors] = useState('All');
  const { salesData, orderType } = useSelector(
    ({ salesData }: RootState) => salesData
  );
  const { users } = useSelector(
    ({ currentOrderData }: RootState) => currentOrderData
  );
  const { floors, orders } = salesData;

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchOrderData = useCallback(async (querySend: string, filters: any) => {
      try {
        const res = await Service.get(`/payments/receipt${querySend}`);
        const data = await res?.data?.paginatedReceipts;
        setOrderData(data);
        dispatch(updateOrderFilters({page: initPage ? 1 : filters.page, limit: filters.limit, totalPages: res?.data?.totalPages}))
        dispatch(updateOrderItemsCache({ query: querySend, data }))
        setInitPage(false)
      } catch (err) {}
    }, []);

    useEffect(() => {
      const paginationQuery = `&page=${filters.page}&limit=${filters.limit}`;
      const querySend = `?searchQuery=${filteredText}&paymentStatus=${orderPaymentType.value}${dateQuery}${paginationQuery}`;
      fetchOrderData(querySend, filters);
    }, []);

  useEffect(() => {
      const paginationQuery = `&page=${filters.page}&limit=${filters.limit}`
      const querySend = `?searchQuery=${filteredText}&paymentStatus=${orderPaymentType.value}${dateQuery}${paginationQuery}`;
      const isRefetchTriggered = refetch;
      if (ordersCache?.query === querySend && !isRefetchTriggered) {
        setOrderData(ordersCache.data);
      } else {
        fetchOrderData(querySend, filters);
      }
      if(isRefetchTriggered) {
        dispatch(triggerOrdersRefetch(false));
      }
    }, [dateQuery, filteredText, orderPaymentType, filters, refetch]);

  const handleOrderTypeClick = (type: string) => {
    if (filteredOrderType.includes(type)) {
      const updatedFilter = filteredOrderType.filter((item) => item !== type);
      setFilteredOrderType(updatedFilter);
    } else {
      const updatedFilter = filteredOrderType.concat(type);
      setFilteredOrderType(updatedFilter);
    }
  };

  const handleSortByClick = (name: string) => {
    if (filteredSortBy === name) {
      setFilteredSortBy('');
    } else {
      setFilteredSortBy(name);
    }
  };

  const handleOrderClick = (id: string) => {
    if (selectedTicket === id) {
      setSelectedTicket('');
      return;
    } else {
      setSelectedTicket(id);
      dispatch(clearCurrentOrder());
      const dataOrders = orders.find((i: any) => i.id === id);
      const userInfo = JSON.parse(
        window.localStorage.getItem('userInfo') || ''
      );
      const user = dataOrders?.customer?.id
        ? users.find((userInfo) => userInfo.id === dataOrders.customer.id)
        : null;
      const a = {
        businessId: userInfo?.businessInfo?.id,
        type: dataOrders.type,
        tableId: dataOrders?.table?.id || null,
        tableName: dataOrders?.table?.name || null,
        userId: dataOrders?.customer?.id || null,
        origin: 'pos_device',
        promo: dataOrders?.promo || null,
        deliveryCharge:
          dataOrders?.type === 'delivery' ? dataOrders.deliveryCharge : 0,
        items:
          dataOrders.ordersItems.length > 0
            ? dataOrders.ordersItems.map((item: any) => {
                return {
                  id: item.id,
                  itemId: item.itemId,
                  name: item.itemName,
                  variantId: item.variantId,
                  hasVariants: item.hasVariants,
                  variantName: item.variantName,
                  identifierId: item.id,
                  quantity: item.quantity,
                  spiceLevel: item.spiceLevel || null,
                  selectedModifiers: item.allModifiers.map((modifier: any) => {
                    const optionsWithSelected = modifier.options.map(
                      (option: any) => {
                        const optionInModifiers = item.modifiers
                          .find((mod: any) => mod.id === modifier.id)
                          ?.options.find((op: any) => op.id === option.id);
                        return {
                          id: option.id,
                          price: option.price,
                          name: option.name,
                          hasSelected: !!optionInModifiers,
                        };
                      }
                    );
                    return {
                      id: modifier.id,
                      name: modifier.name,
                      options: optionsWithSelected,
                    };
                  }),
                  price: item.discountedPrice,
                  note: item?.note || '',
                };
              })
            : [],
      };

      if (dataOrders.ordersItems.length > 0) {
        dispatch(addCurrentOrder({ ...a }));
        if (user) {
          dispatch(
            addCurrentUser({
              id: user.id,
              name: user.name,
              email: user?.email || null,
              phone: parseFloat(user?.phone),
              image: user?.image || null,
            })
          );
        }
      }
    }
  };

  const handleDateChange = (dates: [Date | null, Date | null]) => {
      const [start, end] = dates;
      dispatch(updateOrderDate({orderStartDate: start, orderEndDate: end}))
      if (!start || !end) return;
      const qu = `&from=${getStartOfDay(start).toISOString()}&to=${getEndOfDay(
        end
      ).toISOString()}`;
      setDateQuery(qu);
    };
  const handleClickDiscMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorElFilter(event.currentTarget);
    };
  const handleCloseDiscMenu = () => {
    setAnchorElFilter(null);
  };

  return (
    <>
      <div className="w-full h-[calc(100vh-75px)]   text-black flex flex-row justify-between gap-4  max-h-[100vh] ">
        <div className="w-full mb-5 h-full flex flex-col ">
          <div className="flex flex-row justify-end h-[41px] w-full">
            <div className=" flex flex-row gap-4 items-center">
              <div className="relative flex items-center w-[274px] h-[41px]">
                <input
                  type="text"
                  placeholder="Search open tickets"
                  className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none "
                  onChange={(e) => {
                    setFilteredText(e.target.value);
                  }}
                />
                <div className="absolute right-3">
                  <HiSearch
                    className="text-gray-400"
                    style={{ fontSize: '20px' }}
                  />
                </div>
              </div>
              <button
                className="w-[32] h-[32] cursor-pointer"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <img src={Sort} alt="sort" />
              </button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                    border: '1px solid #F1F0F6',
                    width: '290px',
                    maxHeight: '290px',
                    height: 'fit',
                    backgroundColor: '#FFFFFF',
                    padding: '10px 16px',
                    marginTop: '10px',
                    overflow: 'hidden',
                  },
                }}
              >
                <div className="w-full flex flex-col gap-3 ">
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Order Type
                    </div>
                    <div className="flex flex-wrap gap-2 ">
                      {orderType?.dine_in && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                            filteredOrderType.includes('dine_in')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          }`}
                          onClick={() => handleOrderTypeClick('dine_in')}
                        >
                          Dine In
                        </div>
                      )}
                      {orderType?.takeaway && (
                        <div
                          className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                            filteredOrderType.includes('takeaway')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          } `}
                          onClick={() => handleOrderTypeClick('takeaway')}
                        >
                          Takeaway
                        </div>
                      )}
                      {orderType?.delivery && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                            filteredOrderType.includes('delivery')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          }`}
                          onClick={() => handleOrderTypeClick('delivery')}
                        >
                          Delivery
                        </div>
                      )}

                      {orderType?.online_order && (
                        <div
                          className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px]  ${
                            filteredOrderType.includes('online_order')
                              ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                              : 'border-[#CACFE3] font-normal text-[#7F8397] '
                          } `}
                          onClick={() => handleOrderTypeClick('online_order')}
                        >
                          Online
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Sort by
                    </div>
                    <div className="flex flex-wrap gap-2 ">
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'createdUp'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('createdUp')}
                      >
                        Created <BsArrowUpShort fontSize={18} />
                      </div>
                      <div
                        className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'createdDown'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('createdDown')}
                      >
                        Created <BsArrowDownShort fontSize={18} />
                      </div>
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'amountUp'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        }`}
                        onClick={() => handleSortByClick('amountUp')}
                      >
                        Amount <BsArrowUpShort fontSize={18} />
                      </div>
                      <div
                        className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                          filteredSortBy === 'amountDown'
                            ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                            : 'border-[#CACFE3] font-normal text-[#7F8397] '
                        } `}
                        onClick={() => handleSortByClick('amountDown')}
                      >
                        Amount <BsArrowDownShort fontSize={18} />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                      Filter floors
                    </div>
                    <div className="relative">
                      <select
                        className="w-full h-[36px] rounded-xl border outline-none cursor-pointer border-[#CACFE3] appearance-none px-[20px] font-Outfit font-normal text-xs"
                        value={filterFloors}
                        onChange={(event) => {
                          setFilterFloors(event.target.value);
                        }}
                      >
                        <option value="All">All</option>
                        {floors.map((floor: any) => (
                          <option key={floor.id} value={floor.id}>
                            {floor.name}
                          </option>
                        ))}
                      </select>
                      <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                        <FiChevronDown className="text-gray-400" />
                      </div>
                    </div>
                  </div>
                </div>
              </Menu>
            </div>
            <div className="flex gap-2 items-center ml-4">
              <Button
                text={
                  <div className="flex items-center justify-between w-[120px]">
                    <span>{orderPaymentType.title}</span>
                    <BiChevronDown size={18} />
                  </div>
                }
                id="basic-button-disc"
                aria-controls={openDisc ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openDisc ? 'true' : undefined}
                // @ts-ignore
                onClick={handleClickDiscMenu}
              />
              <Menu
                id="basic-menu"
                anchorEl={anchorElFilter}
                open={openDisc}
                onClose={handleCloseDiscMenu}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                    marginTop: '5px',
                    border: '1px solid #4062FF',
                    height: 'fit-content',
                    backgroundColor: '#FFFFFF',
                    overflow: 'hidden',
                  },
                }}
              >
                {payment_status?.map((each: any, i: number) => (
                  <div
                    key={'payment' + i}
                    className={`font-Outfit px-2 py-2 hover:bg-almost-white font-normal text-[14px] leading-6  cursor-pointer `}
                    onClick={() => {
                      dispatch(updateOrderPaymentType(payment_status[i]))
                      dispatch(updateOrderFilters({page: 1, limit: filters.limit, totalPages: filters.totalPages})),
                      setAnchorElFilter(null);
                    }}
                  >
                    {each.title}
                  </div>
                ))}
              </Menu>
              <ReactDatePicker
                name="date"
                className="w-[fit] appearance-none rounded-xl text-text-black placeholder:capitalize py-3 block placeholder:text-sm px-3 text-sm ring-1 ring-light-grey focus-within:ring-1 focus-within:ring-primary focus-within:outline-0 border-light-gray"
                locale="en-US"
                selected={orderStartDate}
                onChange={handleDateChange}
                startDate={orderStartDate}
                endDate={orderEndDate}
                selectsRange
                placeholderText="MM-DD-YYYY"
              />
            </div>
          </div>
          <div className="mt-4 w-full flex flex-wrap gap-4  h-fit overflow-auto ">
            {orderData.length > 0 ? (
              <>
                {' '}
                {orderData.map((order: any) => {
                  return (
                    <div
                      key={order.id}
                      onClick={() => {
                        handleOrderClick(order.id);
                      }}
                      className={`w-[348px]  p-4 rounded-xl border h-fit  flex flex-col gap-[6px] cursor-pointer ${
                        order.id === selectedTicket
                          ? 'border-primary bg-[#4062FF] bg-opacity-20'
                          : ' border-[#F1F0F6]'
                      }`}
                    >
                      <div className="h-[22px] flex justify-between items-center w-full ">
                        <div className="flex gap-2">
                          {order.orderType === 'dine_in' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiForkKnifeLight color="#7F8397" />
                            </div>
                          )}
                          {order.orderType === 'takeaway' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiShoppingBag color="#7F8397" />
                            </div>
                          )}
                          {order.orderType === 'delivery' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiTruckLight color="#7F8397" />
                            </div>
                          )}
                          {order.orderType === 'online_order' && (
                            <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                              <PiCursor color="#7F8397" />
                            </div>
                          )}
                          {order.origin === 'online' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              WEB
                            </div>
                          )}
                          {order.origin === 'pos_device' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              POS
                            </div>
                          )}
                          {order.origin === 'customer_app' && (
                            <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                              APP
                            </div>
                          )}
                          {PaymentStatusButton(order.status)}
                        </div>
                      </div>
                      <div className="w-full h-[24px] flex justify-between items-center ">
                        <div className="font-Outfit font-semibold text-[16px] leading-6 ">
                          {order?.orderType === 'takeaway' && (
                            <>Takeaway- {order?.referenceNumber}</>
                          )}
                          {order?.orderType === 'delivery' ||
                            (order?.orderType === 'online_order' && (
                              <>Delivery- {order?.referenceNumber}</>
                            ))}
                          {order?.orderType === 'dine_in' && (
                            <>
                              Table- {order?.table?.name} (
                              {order.referenceNumber})
                            </>
                          )}
                        </div>

                        <div className="font-Outfit font-normal text-[16px] leading-6">
                          <CurrencyAmount amount={Math.ceil(order.total)}/>
                        </div>
                      </div>
                      <div className="w-full h-[18px] flex justify-between items-center ">
                        <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                          by {order.employee ? order?.employee?.name : 'owner'}
                        </div>
                        <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                          {moment(order?.createdAt).fromNow()}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div>No tickets found</div>
            )}
          </div>
        </div>
        {selectedTicket ? (
         <Modal
            title={''}
            onClick={()=>setSelectedTicket('')}
            className="w-auto z-[9988]"
            hideCross={true}
            crossContent={``}
          >
            <div className="mt-4">
              <SingleOrder orderId={selectedTicket} />
            </div>
          </Modal>
        ) : (
          <div className="fixed top-0 right-0 h-full">
            <NoTicket />
          </div>
        )}
      </div>
    </>
  );
};

export default ClosedTickets;
